// bus.js文件内容
import Vue from 'vue'
// export default new Vue()
const Bus = new Vue()
export default Bus



// WEBPACK FOOTER //
// ./src/bus.js